import { Reveal } from "@/components/site/Reveal";
import { Icon } from "@/components/site/icons";
import { useLanguage } from "@/context/LanguageContext";

const Presentation = () => {
  const { t } = useLanguage();
  return (
    <section data-testid="presentation-section" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="flex items-center gap-3 mb-5">
                <span className="h-px w-10 bg-[#B87333]" />
                <span className="overline text-[#B87333]">{t.presentation.overline}</span>
              </div>
              <h2 className="font-display text-[#0B1F33] font-extrabold tracking-tighter leading-[1.02] text-4xl lg:text-5xl">
                {t.presentation.title}
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <p className="text-[#4b5563] text-base lg:text-lg leading-relaxed">
                {t.presentation.text}
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 lg:mt-20 grid md:grid-cols-3 gap-6">
          {t.presentation.values.map((v, i) => (
            <Reveal key={v.title} delay={i * 0.1}>
              <div
                data-testid={`value-card-${i}`}
                className="group h-full bg-[#F9FAFB] border border-[#E5E7EB] p-8 hover:border-[#B87333] hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-12 h-12 grid place-items-center bg-[#0B1F33] text-white group-hover:bg-[#B87333] transition-colors duration-300">
                  <Icon name={v.icon} size={22} strokeWidth={1.6} />
                </div>
                <h3 className="mt-6 font-display text-xl font-bold text-[#0B1F33] tracking-tight">
                  {v.title}
                </h3>
                <p className="mt-3 text-[#6B7280] text-sm leading-relaxed">{v.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Presentation;
